module.exports = __webpack_public_path__ + "static/media/energetic_slightly-happy.75481beb.svg";